<template>
    <i class="ico-svg-profile">
        <svg v-bind="{ width, height }" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.353 13.377c-1.34-.46-2.028-1.466-2.377-2.277 1.93-1.178 2.933-3.975 2.933-6.1 0-2.762-2.198-5-4.909-5S4.09 2.238 4.09 5c0 2.127 1.006 4.925 2.937 6.102-.347.817-1.034 1.83-2.37 2.272C2.301 14.152 0 14.406 0 18.334V20h18v-1.667c0-3.869-2.198-4.113-4.647-4.955z" :fill="color"/>
        </svg>
    </i>
</template>

<script>
export default {
    name: 'IconProfile',

    props: {
        width: {
            type: Number,
            default: 18,
        },

        height: {
            type: Number,
            default: 20,
        },

        color: {
            type: String,
            default: 'currentColor',
        },
    },
};
</script>
